// extracted by mini-css-extract-plugin
module.exports = {"container":"Slide_container_mDKNp","slideList":"Slide_slideList_2SJmr","dotList":"Slide_dotList_1q7Lw","active":"Slide_active_5DYYw"};